import * as React from 'react';
// mui
import {
  Alert,
  Button,
  Card,
  Grid,
  Snackbar,
  Typography,
  Box
} from '@mui/material';
// router
import { useNavigate, useSearchParams } from 'react-router';
// axios
import api from '../../axios';

export default function EmailConfirmationPage() {
  const navigate = useNavigate();
  
  const [ searchParams ] = useSearchParams();
  const [ isLoading, setIsLoading ] = React.useState(false);
  const [ showSnackbar, setShowSnackbar ] = React.useState(false);
  const token = searchParams.get('token');

  const handleContinueButtonClick = (e: any) => {
    e.preventDefault();
    setIsLoading(true);
    if (token) {
      api.get(`/auth/confirm?token=${token}`)
        .then((res) => {
          console.log(res);
          navigate('/auth');
        })
        .catch((err) => {
          console.log(err);
          setShowSnackbar(true);
        })
        .finally(() => setIsLoading(false));
    } else {
      setShowSnackbar(true);
      setIsLoading(false)
    }
  }

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: (theme) =>
          `linear-gradient(to bottom right, 
        ${theme.palette.primary.main}44 0%, 
        ${theme.palette.background.default}FF 100%)`
      }}
    >
      <Grid container sx={{ p: 4 }} spacing={4}>
        <Grid size={12}>
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight="calc(100vh - 64px)"
          >
            <Card sx={{ width: 500, p: 3 }}>
              <Typography variant='h6'>Thank you for Verifying your Email!</Typography>
              <Typography>Please click the button below to be taken to the login. You can now login with your new account!</Typography>
              <br />
              <Button loading={isLoading} fullWidth variant='contained' onClick={handleContinueButtonClick}>Continue</Button>
            </Card>
          </Box>
        </Grid>
        <Snackbar
          open={showSnackbar}
          autoHideDuration={6000}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center'
          }}
        >
          <Alert
            severity="error"
            variant="filled"
            sx={{ width: '100%' }}
          >
            There was an error with veryifying your email!
          </Alert>
        </Snackbar>
      </Grid>
    </Box>
  )
}
